import * as actions from "../actions_agent/Type";
const intialState = {
  property: {},
  list_of_sell_property: [],
  list_of_rent_property: [],
  view_sell_detail: {},
  view_rent_detail: {},
  update_property_sell: {},
  update_property_rent: {},
  list_of_required_property: [],
  list_of_required_property_rent: [],
  view_required_detail: {},
  required_property_rent: {},
  sell_pr_agent: {},
  rent_pr_agent: {},
  // CUSTOMER DETAIL
  customer_obj: {},
  list_customer: [],
  view_customer_obj: {},

  customercall_obj: {},
  list_customer_call: [],
  view_customercall_obj: {},

  customerservice_obj: {},
  list_customer_service: [],
  view_customerservice_obj: {},
};
const PropertyReducer = (state = intialState, action) => {
  switch (action.type) {
    case actions.ADD_PROPERTY:
      return {
        ...state,
        property: action.payload,
        list_of_sell_property: [action.payload, ...state.list_of_sell_property],
        list_of_rent_property: [action.payload, ...state.list_of_rent_property],
      };

    case actions.ADD_REQUIRED_PROPERTY:
      return {
        ...state,
        required_property: action.payload,
        list_of_required_property: [
          action.payload,
          ...state.list_of_required_property,
        ],
        list_of_required_property_rent: [
          action.payload,
          ...state.list_of_required_property_rent,
        ],
      };

    case actions.GET_LIST_PROPERTY_SELL:
      return {
        ...state,
        list_of_sell_property: action.payload,
      };

    case actions.GET_LIST_PROPERTY_RENT:
      return {
        ...state,
        list_of_rent_property: action.payload,
      };

    case actions.GET_LIST_PROPERTY_REQUIRED:
      return {
        ...state,
        list_of_required_property: action.payload,
      };
    case actions.GET_LIST_PROPERTY_REQUIRED_RENT:
      return {
        ...state,
        list_of_required_property_rent: action.payload,
      };

    case actions.VIEW_DETAIL_SELL:
      return {
        ...state,
        view_sell_detail: action.payload,
        sell_pr_agent: action.sell_pr_agent,
      };

    case actions.VIEW_DETAIL_REQUIRED_PROPERTY:
      return {
        ...state,
        view_required_detail: action.payload,
      };

    case actions.VIEW_UPDATE_PROPERTY_SELL:
      return {
        ...state,
        update_property_sell: action.payload,
      };
    case actions.VIEW_UPDATE_PROPERTY_RENT:
      return {
        ...state,
        update_property_rent: action.payload,
      };

    case actions.VIEW_DETAIL_REQUIRED_PROPERTY_RENT:
      return {
        ...state,
        required_property_rent: action.payload,
      };

    case actions.VIEW_DETAIL_RENT:
      return {
        ...state,
        view_rent_detail: action.payload,
        rent_pr_agent: action.rent_pr_agent,
      };
    case actions.UPDATEING_PROPERTY_STATUS:
      return {
        ...state,
      };

    case actions.UPDATE_SELL:
      return {
        ...state,
      };

    case actions.UPDATEING_REQUIRED_RENT_STATUS:
      return {
        ...state,
        list_of_required_property_rent:
          state.list_of_required_property_rent.filter(
            (el) => el._id !== action.id
          ),
      };

    case actions.UPDATEING_REQUIRED_SELL_STATUS:
      return {
        ...state,
        list_of_required_property: state.list_of_required_property.filter(
          (el) => el._id !== action.id
        ),
      };

    case actions.UPDATEING_PROPERTY_RENT_STATUS:
      return {
        ...state,
      };

    case actions.UPDATEING_PROPERTY_SELL_STATUS:
      return {
        ...state,
      };
    case actions.UPDATE_RENT:
      return {
        ...state,
      };
    case actions.UPDATEING_PROPERTY_REQUIRED_STATUS:
      return {
        ...state,
      };
    case actions.DELETE_AVILABLEPROPERTY:
      return {
        ...state,
        list_of_sell_property: state.list_of_sell_property.filter(
          (el) => el._id !== action.id
        ),
      };
    case actions.DELETE_AVILABLEPROPERTY_RENT:
      return {
        ...state,
        list_of_rent_property: state.list_of_rent_property.filter(
          (el) => el._id !== action.id
        ),
      };
    case actions.UPDATE_REQUIRED_PROPERTY:
      return {
        ...state,
      };
    case actions.CREATE_DETAIL_OF_CUSTOMER:
      return {
        ...state,
        customer_obj: action.payload,
        list_customer: [action.payload, ...state.list_customer],
      };
    case actions.GET_DETAIL_OF_CUSTOMER:
      return {
        ...state,
        list_customer: action.payload,
      };

    case actions.CUSTOMER_VIEWED:
      return {
        ...state,
        view_customer_obj: action.payload,
      };
    case actions.CISTOMER_UPDATED:
      return {
        ...state,
      };
    case actions.CUSTOMER_DELETED:
      return {
        ...state,
        list_customer: state.list_customer.filter((el) => el._id !== action.id),
      };

    case actions.CREATE_CALL_CUSTOMER:
      return {
        ...state,
        customercall_obj: action.payload,
        list_customer_call: [action.payload, ...state.list_customer_call],
      };
    case actions.GET_CALL_CUSTOMER:
      return {
        ...state,
        list_customer_call: action.payload,
      };

    case actions.CUSTOMERCALL_VIEWED:
      return {
        ...state,
        view_customercall_obj: action.payload,
      };
    case actions.CISTOMERCALL_UPDATED:
      return {
        ...state,
      };
    case actions.CUSTOMERCALL_DELETED:
      return {
        ...state,
        list_customer_call: state.list_customer_call.filter(
          (el) => el._id !== action.id
        ),
      };
    // customer service
    case actions.CREATE_SERVICE_CUSTOMER:
      return {
        ...state,
        customerservice_obj: action.payload,
        list_customer_service: [action.payload, ...state.list_customer_service],
      };
    case actions.GET_SERVICE_CUSTOMER:
      return {
        ...state,
        list_customer_service: action.payload,
      };

    case actions.CUSTOMERSERVICE_VIEWED:
      return {
        ...state,
        view_customerservice_obj: action.payload,
      };
    case actions.CISTOMERSERVICE_UPDATED:
      return {
        ...state,
      };
    case actions.CUSTOMERSERVICE_DELETED:
      return {
        ...state,
        list_customer_service: state.list_customer_service.filter(
          (el) => el._id !== action.id
        ),
      };
    default:
      return { ...state };
  }
};

export default PropertyReducer;
